module.exports = __webpack_public_path__ + "img/zhangjiasheng.9c560406.jpg";